module.exports = __webpack_public_path__ + "static/media/e-commerce-in-covid-19.d5deba63.svg";